import { ThirdPartyBlock } from './ThirdPartyBlock';
import register from './register';

register(ThirdPartyBlock);
